import React from 'react';
import { connect } from 'react-redux';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import animator from '../../../../helpers/animator';
import AnalyticsLogger from '../../../../helpers/analytics/analyticsLogger';
import FileUtil from '../../../../helpers/FileUtil/FileUtil';
import Metadata from '../../../../helpers/metadata/Metadata';
import dataModel from '../../../../models/DataModel';
import ImageTools from '../../../../helpers/ImageTools';

import TrashIcon from '../../../Iconoclast/TrashIcon';
import './DocumentsListItem.scss';

export class DocumentsListItem extends BaseComponent {
  constructor(props) {
    super(props);
    this.animator = new animator();
    this.state = {};    

    this.isMobile = dataModel.mobileBridge.isMobile;
    //init analytics
    const currentRole = props.currentUser ? props.currentUser.role : null;
    this.analyticsLogger = new AnalyticsLogger({
      currentRole,
      isMobile: this.isMobile,
    });
  }

  handleGetTypeImage(attachmentType){
    return ImageTools.getIconForFile(attachmentType);
  }

  // TODO: consolidate these web/mobile handlers and make logs generic
  handleMobileDownload(){
    const { document, handleOpenDoc } = this.props;
    if(handleOpenDoc){
      handleOpenDoc(document);
    }
    this.logReferenceDocDownload(document);
  }

  handleViewDocument(e) {
    if (this.props.document.id >= 0) {
      if(this.props.document.attachment_content_type == 'application/vnd.google-earth.kmz'){
        const link = document.createElement('a');
        link.href = this.props.document.attachment;
        document.body.appendChild(link);
        link.click();
      }
      else{
        if (this.props.displayDocument) {
          this.props.displayDocument(this.props.document);
          this.logReferenceDocDownload(this.props.document);
        }
      }
    }
  }

  handleDeleteDocument(e) {
    e.stopPropagation();
    if (this.props.document.id >= 0) {
      this.props.handleDeleteDocument(this.props.document.id);
    }
  }

  logReferenceDocDownload(referenceDoc) {
    const extension = referenceDoc.name.split('.')[1];
    const body = `${this.props.currentUser.name} downloaded ${referenceDoc.name}`;
    Metadata.logEventHistory('Reference Document Download', extension, body);
  }

  render() {
    const { document, canDeleteDocument } = this.props;
    
    if (!document || !document.id) {
      return null;
    }
    let attachmentType = FileUtil.getExtension(document.name);
    let typeImage = this.handleGetTypeImage(attachmentType);

    if (this.isMobile) {
      return (
        <div className="document-list-item" onClick={this.handleMobileDownload}>
          <div className={'item-info'}>
            <div className="title">{document.name}</div>
          </div>
          <div className='icons'>
            <img className="icons__type" src={typeImage} alt="type" />
            <div id='downloadFile' className='icons__arrow' />
          </div>
        </div>
      );

    } else return (
        <div className={'document-list-item' + (canDeleteDocument ? ' document-list-item--with-delete' : '')} onClick={this.handleViewDocument} data-id={document.id}>
          <div className={'item-info'} data-id={document.id}>
            <div className="title" data-id={document.id}>{document.name}</div>
          </div>
          <div className='icons'>
            <img className="icons__type" src={typeImage} alt="type"  data-id={document.id + '-type'}/>
            {canDeleteDocument && this.props.document.id >= 0 &&
              <div className='icons__trash' onClick={this.handleDeleteDocument} data-id={document.id + '-delete'}>
              <TrashIcon />
              </div>
            }
          </div>
        </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.new_users ? state.new_users.currentUser : null,
  };
};
export default connect(mapStateToProps)(DocumentsListItem);



// WEBPACK FOOTER //
// ./src/components/TaskCRUD/DocumentsList/DocumentsListItem/index.js